var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockChainDevelopmentTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6029 6.81723C36.9656 3.43785 25.0049 4.72173 18.3951 10.756C13.7281 15.0166 17.3403 16.231 20.5221 24.0272C22.825 29.6698 0 28.8932 0 39.0892C0 50.8766 16.5314 48.6422 22.6661 49.9915C32.0456 52.0545 40.2281 59.7717 50.2496 58.7544C58.974 57.8686 62.3 51.0225 63.5132 43.1741C65.7735 28.5521 60.2221 12.5372 45.6029 6.81723Z",
    fill: "url(#paint0_linear_1543_53669)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M59.5356 21.8063L54.0436 19.575C56.6726 18.5619 58.5308 16.0863 58.5308 13.1907C58.5308 9.39367 55.3372 6.31567 51.3976 6.31567C47.458 6.31567 44.2643 9.39367 44.2643 13.1907C44.2643 16.1352 46.1855 18.6462 48.8852 19.6258L43.518 21.8064V25.3317L39.9217 23.8705L40.0305 23.8264V13.7403L32.0215 10.4863L24.0126 13.7402V23.8263L24.081 23.854L20.4826 25.316V21.8063L12.4737 18.5524L4.46484 21.8063V31.4718C4.46484 31.7262 4.61897 31.955 4.85459 32.0508L12.4737 35.1463L17.9826 32.9082V37.3845L12.4737 35.1463L4.46484 38.4002V48.0657C4.46484 48.32 4.61897 48.5489 4.85459 48.6447L7.58572 49.7543C6.27934 51.0004 5.46947 52.729 5.46947 54.6404C5.46947 58.4374 8.66309 61.5154 12.6027 61.5154C16.5423 61.5154 19.736 58.4374 19.736 54.6404C19.736 52.6912 18.8928 50.9327 17.5406 49.6815L20.4823 48.4863V44.9767L24.1268 46.4574L24.0103 46.5048V56.1703C24.0103 56.4247 24.1645 56.6535 24.4001 56.7493L32.0192 59.8448L39.6383 56.7493C39.874 56.6535 40.0281 56.4245 40.0281 56.1703V46.5048L39.8732 46.4419L43.5177 44.9612V48.0657C43.5177 48.32 43.6718 48.5489 43.9075 48.6447L51.5266 51.7402L59.1457 48.6447C59.3813 48.5489 59.5355 48.3199 59.5355 48.0657V38.4002L51.5266 35.1463L45.9793 37.4001V32.8926L51.5265 35.1463L59.1456 32.0508C59.3812 31.955 59.5353 31.726 59.5353 31.4718V21.8063H59.5356Z",
    fill: "#9C4FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0206 7.48633L24.0117 10.7401L32.0206 13.994L40.0295 10.7401L32.0206 7.48633Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0304 20.8264L32.0215 24.0802V13.994L40.0304 10.7401V20.8264Z",
    fill: "#DDC2FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5508 15.5381V15.5525",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5234 14.7881V14.8025",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0206 13.994L24.0117 10.7401V20.8264L32.0206 24.0802V13.994Z",
    fill: "#DDC2FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0206 7.48633L24.0117 10.7401L32.0206 13.994L40.0295 10.7401L32.0206 7.48633Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0304 20.8264L32.0215 24.0802V13.994L40.0304 10.7401V20.8264Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0206 13.9941L24.0117 10.7402V16.9857",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5265 15.5525L43.5176 18.8064L51.5265 22.0602L59.5353 18.8064L51.5265 15.5525Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5362 28.8925L51.5273 32.1464V22.0603L59.5362 18.8064V28.8925Z",
    fill: "#DDC2FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7949 23.5942V23.6086",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7676 22.8442V22.8586",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5265 22.0603L43.5176 18.8064V28.8925L51.5265 32.1464V22.0603Z",
    fill: "#DDC2FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5265 15.5525L43.5176 18.8064L51.5265 22.0602L59.5353 18.8064L51.5265 15.5525Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5362 28.8925L51.5273 32.1464V22.0603L59.5362 18.8064V28.8925Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5265 22.0603L43.5176 18.8064V28.8925L51.5265 32.1464V22.0603Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 15.5525L4.46484 18.8064L12.4737 22.0602L20.4826 18.8064L12.4737 15.5525Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4835 28.8925L12.4746 32.1464V22.0603L20.4835 18.8064V28.8925Z",
    fill: "#DDC2FF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7422 23.5942V23.6086",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 22.8442V22.8586",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 22.0603L4.46484 18.8064V28.8925L12.4737 32.1464V22.0603Z",
    fill: "#DDC2FF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 15.5525L4.46484 18.8064L12.4737 22.0602L20.4826 18.8064L12.4737 15.5525Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4835 28.8925L12.4746 32.1464V22.0603L20.4835 18.8064V28.8925Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 22.0603L4.46484 18.8064V28.8925L12.4737 32.1464V22.0603Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9809 17.6443L17.9824 23.3317L31.9809 29.019L45.9793 23.3317L31.9809 17.6443Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9788 40.961L31.9805 46.6483V29.019L45.9788 23.3317V40.961Z",
    fill: "#DDC2FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9809 29.019L17.9824 23.3317V40.961L31.9809 46.6483V29.019Z",
    fill: "#DDC2FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9809 17.6443L17.9824 23.3317L31.9809 29.019L45.9793 23.3317L31.9809 17.6443Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9788 40.961L31.9805 46.6483V29.019L45.9788 23.3317V40.961Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9809 29.019L17.9824 23.3317V40.961L31.9809 46.6483V29.019Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0185 40.251L24.0098 43.5049L32.0185 46.7587L40.0274 43.5049L32.0185 40.251Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0265 53.591L32.0176 56.8449V46.7588L40.0265 43.5049V53.591Z",
    fill: "#DDC2FF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5508 48.1443V48.1587",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5234 47.3943V47.4087",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0185 46.7588L24.0098 43.5049V53.591L32.0185 56.8449V46.7588Z",
    fill: "#DDC2FF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0185 40.251L24.0098 43.5049L32.0185 46.7587L40.0274 43.5049L32.0185 40.251Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0265 53.591L32.0176 56.8449V46.7588L40.0265 43.5049V53.591Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0185 46.7588L24.0098 43.5049V53.591L32.0185 56.8449V46.7588Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5449 30.5507V30.565",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5176 29.8007V29.815",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5265 32.1464L43.5176 35.4002L51.5265 38.6541L59.5353 35.4002L51.5265 32.1464Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5362 45.4864L51.5273 48.7403V38.6541L59.5362 35.4003V45.4864Z",
    fill: "#DDC2FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M53.7949 40.1881V40.2025",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7676 39.4381V39.4525",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5265 38.6541L43.5176 35.4003V45.4864L51.5265 48.7403V38.6541Z",
    fill: "#DDC2FF"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5265 32.1464L43.5176 35.4002L51.5265 38.6541L59.5353 35.4002L51.5265 32.1464Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4912 46.3173L59.5362 45.4864V35.4003L51.5273 38.6541V48.7403L53.8511 47.7963",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5265 38.6541L43.5176 35.4003V45.4864L51.5265 48.7403V38.6541Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 32.1464L4.46484 35.4002L12.4737 38.6541L20.4826 35.4002L12.4737 32.1464Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4835 45.4864L12.4746 48.7403V38.6541L20.4835 35.4003V45.4864Z",
    fill: "#DDC2FF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7422 40.1881V40.2025",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7148 39.4381V39.4525",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 38.6541L4.46484 35.4003V45.4864L12.4737 48.7403V38.6541Z",
    fill: "#DDC2FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 32.1464L4.46484 35.4002L12.4737 38.6541L20.4826 35.4002L12.4737 32.1464Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4835 45.4864L12.4746 48.7403V38.6541L20.4835 35.4003V45.4864Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4737 38.6541L4.46484 35.4003V45.4864L12.4737 48.7403V38.6541Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M12.602 58.5154C16.5416 58.5154 19.7352 55.4373 19.7352 51.6404C19.7352 47.8434 16.5416 44.7654 12.602 44.7654C8.66241 44.7654 5.46875 47.8434 5.46875 51.6404C5.46875 55.4373 8.66241 58.5154 12.602 58.5154Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M12.602 58.5154C16.5416 58.5154 19.7352 55.4373 19.7352 51.6404C19.7352 47.8434 16.5416 44.7654 12.602 44.7654C8.66241 44.7654 5.46875 47.8434 5.46875 51.6404C5.46875 55.4373 8.66241 58.5154 12.602 58.5154Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7463 53.09C11.577 53.09 12.2504 52.441 12.2504 51.6404C12.2504 50.8398 11.577 50.1908 10.7463 50.1908C9.91561 50.1908 9.24219 50.8398 9.24219 51.6404C9.24219 52.441 9.91561 53.09 10.7463 53.09Z",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 51.6404H15.9598V52.9693",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 51.6404V52.9693",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3969 17.0657C55.3365 17.0657 58.5302 13.9876 58.5302 10.1907C58.5302 6.39372 55.3365 3.31567 51.3969 3.31567C47.4573 3.31567 44.2637 6.39372 44.2637 10.1907C44.2637 13.9876 47.4573 17.0657 51.3969 17.0657Z",
    fill: "#DDC2FF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3969 17.0657C55.3365 17.0657 58.5302 13.9876 58.5302 10.1907C58.5302 6.39372 55.3365 3.31567 51.3969 3.31567C47.4573 3.31567 44.2637 6.39372 44.2637 10.1907C44.2637 13.9876 47.4573 17.0657 51.3969 17.0657Z",
    stroke: "#9C4FFF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5412 11.6403C50.3719 11.6403 51.0454 10.9913 51.0454 10.1907C51.0454 9.39011 50.3719 8.74109 49.5412 8.74109C48.7105 8.74109 48.0371 9.39011 48.0371 10.1907C48.0371 10.9913 48.7105 11.6403 49.5412 11.6403Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0449 10.1907H54.7547V11.5194",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M52.959 10.1907V11.5194",
    stroke: "white",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0391 56.5673C48.7639 56.5673 49.3516 55.9796 49.3516 55.2548C49.3516 54.5299 48.7639 53.9423 48.0391 53.9423C47.3142 53.9423 46.7266 54.5299 46.7266 55.2548C46.7266 55.9796 47.3142 56.5673 48.0391 56.5673Z",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1133 5.73462C17.8382 5.73462 18.4258 5.14699 18.4258 4.42212C18.4258 3.69725 17.8382 3.10962 17.1133 3.10962C16.3884 3.10962 15.8008 3.69725 15.8008 4.42212C15.8008 5.14699 16.3884 5.73462 17.1133 5.73462Z",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4746 11.0801C13.1995 11.0801 13.7871 10.4925 13.7871 9.76758C13.7871 9.0427 13.1995 8.45508 12.4746 8.45508C11.7497 8.45508 11.1621 9.0427 11.1621 9.76758C11.1621 10.4925 11.7497 11.0801 12.4746 11.0801Z",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3438 57.8621L42.0938 59.1121",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1895 4.69507L40.9395 5.94507",
    stroke: "#DDC2FF",
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1543_53669",
    x1: 13.8456,
    y1: 57.4612,
    x2: 55.3229,
    y2: 15.9839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockChainDevelopmentTestIcon);
export default __webpack_public_path__ + "static/media/block-chain-development-test-icon.9f1bf47a9c9619879f277c7a14c949fa.svg";
export { ForwardRef as ReactComponent };